import { Flex, Text, VStack } from '@chakra-ui/react';
import { FormikHelpers, useFormikContext } from 'formik';

import { useLEAccordionItemContext } from '../../../../../components/LEAccordion/LEAccordionItem/useLEAccordionItem';
import Button from '../../../../../components/ui/buttons/Button';
import StepQuestions from '../conditionReport/StepQuestions';
import {
  SchemaStep,
  buildMissingSectionsMessage,
  collectInvalidSectionLabels,
  stepHasUnansweredText,
} from '../conditionReport/encodeDecodeAnswers';

type FormikBag = Pick<FormikHelpers<Record<string, unknown>>, 'setTouched' | 'validateForm'>;

export type SaveConditionStep = (
  values: Record<string, unknown>,
  step: SchemaStep,
  formik: FormikBag,
) => Promise<boolean>;

type MarketplacePrelistConditionStepContentProps = {
  step: SchemaStep;
  isSaving: boolean;
  saveStep: SaveConditionStep;
};

const MarketplacePrelistConditionStepContent = ({
  step,
  isSaving,
  saveStep,
}: MarketplacePrelistConditionStepContentProps) => {
  const { values, errors, touched, setTouched, validateForm } =
    useFormikContext<Record<string, unknown>>();
  const { updateState, setOpenAccordionIndex, index } = useLEAccordionItemContext();

  const missingSectionsMessage = buildMissingSectionsMessage(
    collectInvalidSectionLabels(step, errors, touched),
  );

  const handleSubmit = async () => {
    const ok = await saveStep(values, step, { setTouched, validateForm });
    if (!ok) return;
    updateState({ status: 'complete' });
    setOpenAccordionIndex(index + 1);
  };

  return (
    <VStack spacing={5} align="stretch">
      <StepQuestions step={step} />
      <Flex justify="center" pt={2}>
        <Button
          variant="primary"
          onClick={handleSubmit}
          isLoading={isSaving}
          isDisabled={stepHasUnansweredText(step, values)}
          loadingText="Saving..."
          px={10}
        >
          NEXT
        </Button>
      </Flex>
      {missingSectionsMessage && (
        <Text fontSize="sm" color="leaseEndRed" textAlign="center">
          {missingSectionsMessage}
        </Text>
      )}
    </VStack>
  );
};

export default MarketplacePrelistConditionStepContent;
